import * as styles from "./MonthPickerMonth.css";

import type { JSX } from "react";

import { useMonthPickerContext } from "./MonthPicker.context";
import type { MonthPickerMonthProps } from "./MonthPicker.types";

export function MonthPickerMonth({
  year,
  month,
  selected,
  current,
  active,
  disabled,
}: MonthPickerMonthProps): JSX.Element {
  const { selectMonth, locale } = useMonthPickerContext();

  const label = new Intl.DateTimeFormat(locale, { month: "short" }).format(
    new Date(year, month, 1),
  );

  const name = new Intl.DateTimeFormat(locale, {
    month: "long",
    year: "numeric",
  }).format(new Date(year, month, 1));

  return (
    <button
      type="button"
      role="gridcell"
      data-slot="month-picker-month"
      data-year={year}
      data-month={month}
      data-current={current ? "" : undefined}
      data-selected={selected ? "" : undefined}
      aria-selected={selected}
      aria-disabled={disabled}
      aria-label={name}
      tabIndex={active ? 0 : -1}
      disabled={disabled}
      className={styles.month}
      onClick={() => selectMonth(year, month)}
    >
      <span className={styles.band}>
        <span className={styles.ring} />
        <span className={styles.ring} />
      </span>
      <span className={styles.label}>{label}</span>
    </button>
  );
}
